import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import { Collapse, Button } from 'reactstrap';
import CircularButtonGroup from '../../../../../_components/common/CircularButtonGroup';
import ReactSpeedometer from "../../../../../_components/common/CustomSpeedometer/CustomSpeedometer";
import ModularTooltip from '../../../../../_components/common/ModularTooltip';
import CompetencyGraph from '../../../../../_components/common/CompetencyGraph';
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions, role_fitmentAction } from '../../../../../_actions';

import compatibilityIcon from '../../../../../images/compatibilityIcon.png';

import role_fitment_compatibilityIcon from '../../../../../images/role_fitment_compatibilityIcon.png';
import role_fitment_individualicon from '../../../../../images/role_fitment_individualicon.png';


import './index.css';


class RoleFitment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teamName: '',
            teamId: '',
            getPaUserPermissionListResponse: '',
            collapse_team: false,
            collapse_role: false,
            collapse_team_members: false,
            name: '',
            role: '',
            holder_name: '',
            team_name: '',
            Tooltip: false,
            traceable_value: null,
            selected_route_parameter: null,
            navData: [],
            team_data: [],
            rootTeamData: [],
            role_data: [],
            data: [],
            individual_members: [],
            subData: [],
            speedoValue: 0,
            individualSelectedObject: {
                name: '',
                id: 0
            },
            headerColor: 'linear-gradient(to right, #3DE100 , ${this.state.graphColor})',
            continuesHeaderColor: 'linear-gradient(to right, #3DE100 , ${this.state.graphColor})'
        }
    }

    componentDidMount() {
        this.storeFitmentsInState();
        this.storeHoldersInState();


        if(this.props.saveAssesorIdsResponse.assessorIds) {
            if(this.props.saveAssesorIdsResponse.assessorIds.length) {
                if(this.props.match.params.fitment && this.props.match.params.holder) {
                    this.fetchRoleFitments(this.props.match.params.holder, this.props.match.params.fitment, this.props.saveAssesorIdsResponse.assessorIds, [+this.props.match.params.assessment])
                }else {

                    //on loading the page save assessors wont update so check while mounting
                    this.setState({
                        individual_data_copy: this.props.saveAssesorGroupListResponse.team_members.filter(member => member.filtered !== undefined ? member.filtered ? member : false : member),
                        individual_members: this.props.saveAssesorGroupListResponse.team_members.filter(member => member.filtered !== undefined ? member.filtered ? member : false : member),
                        collapse_team_members: false
                    })
                }
            }
        }

        //header
        const temp = [];
        if (localStorage.getItem("is_pa_user") == "true") {
        temp.push({
            navName: "Analyze",
            link: `/organisation/${this.props.match.params.id}/user`
        });
        }
        if (localStorage.getItem("is_org_admin") == "true") {
        temp.push({
            navName: "Org Admin Area",
            link: `/organisation/${this.props.match.params.id}/org-admin`
        });
        }
        if (localStorage.getItem("is_success") == "true") {
        temp.push({
            navName: "Super Admin Area",
            link: `/organisation/${this.props.match.params.id}/super-admin`
        });
        }
        this.setState({ navData: temp });
    }

    fetchRoleFitments = (holder_id, fitment_id, relation_group_ids, user_assessment_ids) => {
        const { dispatch } = this.props;
        // { "user_assessment_ids":[3,2], "holder_id":1, "fitment_id":1, "relation_group_ids":[1,2,3] }

        dispatch(role_fitmentAction.role_fitment_fitmentAction({ user_assessment_ids, holder_id, fitment_id, relation_group_ids }))
    }

    teamCheckFunction = (event) => {
        let team_data = this.state.team_data


        let team_data_id = 0

        team_data.forEach(team_data => {
            if (team_data.name == event.target.value) {
                team_data.isChecked = event.target.checked
                team_data_id = team_data.id
            }else {
                team_data.isChecked = false
            }
        })

        this.setState({ team_data: team_data, name: team_data_id })
    
    }

    roleCheckFunction = (event, id, name) => {
        let role_data = this.state.role_data

        let role_data_id = 0

        role_data.forEach(role_data => {
            if (role_data.id === id) {
                role_data_id = id
                role_data.isChecked = true
            } else if (role_data.id !== id) {
                role_data.isChecked = false
            }
        })

        const team_data = this.state.rootTeamData.filter(rootTeam => rootTeam.holder_id === id)

        this.setState({ role_data: role_data, role: role_data_id, team_data, collapse_team: team_data.length ? true : false })
    }

    storeFitmentsInState() {
        if(this.props.role_user_FitmentData) {
            const team_data = this.props.role_user_FitmentData.data.fitment_list.map(fitments => {
                return {
                    ...fitments,
                    name: fitments.fitment_name,
                    isChecked: false
                }
            })

            this.setState({
                rootTeamData: team_data
            })
        }
    }

    getFitmentsNameFromId = () => {
        if(this.props.role_user_FitmentData) {
            const fitment_name = this.props.role_user_FitmentData.data.fitment_list.filter(fitment => this.props.match.params.fitment == fitment.id).reduce((acc, fitment) => (acc + fitment.fitment_name), '')
            return fitment_name
        }else {
            return 'loading....'
        }
    }

    getParticipantNameFromId = () => {
        if(this.props.saveAssesorGroupListResponse !== '') {
            const participantArr = this.props.saveAssesorGroupListResponse.team_members.filter(member => this.props.match.params.assessment == member.assessment.id)
            const participant = participantArr[0] ? participantArr[0].user__full_name ? participantArr[0].user__full_name : participantArr[0].user_email : ""
            return participant
        }else {
            return 'loading....'
        }
    }

    storeHoldersInState() {
        if(this.props.holder_user_FitmentData) {

            const role_data = this.props.holder_user_FitmentData.data.holder_list.map(holder => {
                return {
                    ...holder,
                    isChecked: false
                }
            })

            

            this.setState({
                role_data,
                collapse_role: false
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if (this.props.headPerLoadingResonse !== "") {
              const temp = [];
              if (localStorage.getItem("is_pa_user") == "true") {
                temp.push({
                  navName: "Analyze",
                  link: `/organisation/${this.props.match.params.id}/user`
                });
              }
              if (localStorage.getItem("is_org_admin") == "true") {
                temp.push({
                  navName: "Org Admin Area",
                  link: `/organisation/${this.props.match.params.id}/org-admin`
                });
              }
              if (localStorage.getItem("is_success") == "true") {
                temp.push({
                  navName: "Super Admin Area",
                  link: `/organisation/${this.props.match.params.id}/super-admin`
                });
              }
              this.setState({ navData: temp });
            }
        }

        if(prevProps.role_fitment_data_Data !== this.props.role_fitment_data_Data) {
            if(this.props.role_fitment_data_Data) {
                // {
                //     title: "Research and Learning",
                //     title_value: 8.0,
                // }

                let speedoValue = 0;
                let speedoAvgCounter = 0;

                const dataArr = this.props.role_fitment_data_Data.data.individual.map(fitmentData => {
                    

                    for (let i = 0; i < fitmentData.attributes.length; i++) {
                        const element = fitmentData.attributes[i];
                        speedoValue = speedoValue + element.meter_value;
                        speedoAvgCounter++
                    }

                    return {
                        ...fitmentData,
                        title: fitmentData.competency_name,
                        title_value: fitmentData.attributes.reduce((acc, attr) => {
                            return acc + attr.meter_value
                        }, 0) / fitmentData.attributes.length
                    }
                })

                

                const getSpeedoValueToBeInCenter = (value) => {
                    if(value < 6.1) {
                        return 1
                    }else if(value >= 6.1 && value < 7.1) {
                        return 3
                    }else if(value >= 7.1 && value < 8.1) {
                        return 5
                    }else if(value >= 8.1 && value < 9.1) {
                        return 7
                    }else {
                        return 9
                    }
                }
                
                speedoValue = getSpeedoValueToBeInCenter((speedoValue/speedoAvgCounter))

                this.setState({
                    data: dataArr,
                    speedoValue: speedoValue * 10
                })
            }
        }

        if(prevProps.saveAssesorIdsResponse.assessorIds !== this.props.saveAssesorIdsResponse.assessorIds) {
            if(this.props.saveAssesorIdsResponse.assessorIds) {
                if(this.props.saveAssesorIdsResponse.assessorIds.length) {
                    if(this.props.match.params.fitment && this.props.match.params.holder) {
                        const checkIfAssessmentExistsInMemberList = this.props.saveAssesorIdsResponse.assessmentIds.includes(+this.props.match.params.assessment)
                        if(checkIfAssessmentExistsInMemberList) {
                            this.fetchRoleFitments(this.props.match.params.holder, this.props.match.params.fitment, this.props.saveAssesorIdsResponse.assessorIds, [+this.props.match.params.assessment])
                        }else {
                            this.props.history.push(`/organisation/${this.props.match.params.id}/user/role-fitment`)
                        }
                    }
                }
            }
        }

        if(prevProps.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse.team_members) {
                this.setState({
                    individual_data_copy: this.props.saveAssesorGroupListResponse.team_members.filter(member => member.filtered !== undefined ? member.filtered ? member : false : member),
                    individual_members: this.props.saveAssesorGroupListResponse.team_members.filter(member => member.filtered !== undefined ? member.filtered ? member : false : member),
                    collapse_team_members: false
                })
            }
        }

        if(prevProps.role_user_FitmentData !== this.props.role_user_FitmentData) {
            this.storeFitmentsInState()
        }

        if(prevProps.holder_user_FitmentData !== this.props.holder_user_FitmentData) {
            this.storeHoldersInState()
        }

        if(prevState.speedoValue !== this.state.speedoValue) {
            if(this.state.speedoValue < 20) {
                this.setState({
                    graphColor: '#ed3833',
                    headerColor: 'linear-gradient(to right, #ef6237 , #ee4f35)',
                    continuesHeaderColor: 'linear-gradient(to right, #ee4f35 , #ed3833)'
                })
            }else if(this.state.speedoValue < 40 && this.state.speedoValue >= 20) {
                this.setState({
                    graphColor: '#ec6937',
                    headerColor: 'linear-gradient(to right, #facd48 , #f6af42)',
                    continuesHeaderColor: 'linear-gradient(to right, #f6af42 , #ec6937)'
                })
            }else if(this.state.speedoValue < 60 && this.state.speedoValue >= 40) {
                this.setState({
                    graphColor: '#facd48',
                    headerColor: 'linear-gradient(to right, #facd48 , #facd48)',
                    continuesHeaderColor: 'linear-gradient(to right, #facd48 , #facd48)'
                })
            }else if(this.state.speedoValue < 80 && this.state.speedoValue >= 60) {
                this.setState({
                    graphColor: '#80bd33',
                    headerColor: 'linear-gradient(to right, #80bd33 , #80bd33)',
                    continuesHeaderColor: 'linear-gradient(to right, #80bd33 , #80bd33)'
                })
            }else {
                this.setState({
                    graphColor: '#479c36',
                    headerColor: 'linear-gradient(to right, #68df5e , #5ecb52)',
                    continuesHeaderColor: 'linear-gradient(to right, #5ecb52 , #479c36)'
                })
            }
        }
    }

    renderCustomComponent(val, subData) {
        return (
            <div>
                <p className="pt-2">Ability to make appropriate and quick
                    decisions that have long term benefits
                    and address the context well.</p>
                <div className="d-flex flex-row flex-wrap my-2">
                    {
                        subData.map(
                            (data, i) => {
                                return <React.Fragment key={i}>
                                    <div className="col-8 pl-2 border">
                                        <small className="font-weight-bold">{data.name}</small>
                                    </div>
                                    <div className="col-4 px-0 border text-center font-weight-bold" style={{ backgroundColor: 'rgb(179,178,179)' }}>
                                        <small className="font-weight-bold">{data.value}</small>
                                    </div>
                                </React.Fragment>
                            }
                        )
                    }
                </div>
            </div>
        )
    }

    renderReusables(data) {
        return (
            <div className="d-flex flex-row align-items-center align-self-center mx-0">
                <CircularButtonGroup buttonGroupData={[{
                    img: `${data.img}`,
                    name: "Compatibility",
                    id: 1,
                    tooltip_id: 0
                }]} swotCatagory={1} singleButton={true} uncontrolledButton={true} text-align={'justify-content-start'} />
                <div className="p-2" style={{ background: "linear-gradient(90deg, #69a3e6, #4fc6f9)", width: 100 }}>
                    <h6 className="mb-0 text-center">{data.name}</h6>
                </div>
            </div>
        )
    }

    onActionInvoked = (key, val) => {
        
        let makeObj = []
        const attributes = val.attributes.map(attr => {
            attr.attributes.map(attrnextlevel => {
                makeObj.push({
                    name: attrnextlevel.attribute_name,
                    value: attrnextlevel.average_score
                })
            })
            return {
                ...attr,
            }
        })

        let keyObjectStoringAttributes = {}

        for(var i = 0; i < makeObj.length; i++) {
            if(keyObjectStoringAttributes[makeObj[i].name]) {
                keyObjectStoringAttributes[makeObj[i].name] = {
                    itterated: keyObjectStoringAttributes[makeObj[i].name].itterated + 1,
                    value: keyObjectStoringAttributes[makeObj[i].name].value + makeObj[i].value,
                    avg: (keyObjectStoringAttributes[makeObj[i].name].value + makeObj[i].value) / (keyObjectStoringAttributes[makeObj[i].name].itterated + 1)
                }
            }else {
                keyObjectStoringAttributes[makeObj[i].name] = {
                    itterated: 1,
                    value: makeObj[i].value,
                    avg: makeObj[i].value
                }
            }
        }

        let subData = []

        for (const key in keyObjectStoringAttributes) {
            if (keyObjectStoringAttributes.hasOwnProperty(key)) {
                const element = keyObjectStoringAttributes[key];
                subData.push({
                    name: key,
                    value: element.avg
                })
            }
        }

        this.setState({ subData, selected_route_parameter: key, Tooltip: !this.state.Tooltip, traceable_value: val })
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    callback() {
        this.setState({ Tooltip: false })
    }


    actionRoleFitment = () => {
        this.props.history.push(`/organisation/${this.props.match.params.id}/user/role-fitment/${this.state.individualSelectedObject.id}/${this.state.role}/${this.state.name}`)
    }

    applyButtonBool = () => {
        return this.state.team_data.some(team => {
            return team.isChecked
        }) && this.state.role_data.some(role => {
            return role.isChecked
        }) && this.state.individualSelectedObject.id
    }

    individualCheckFunction = (e, id, name) => {
        const individualSelectedObject = this.state.individualSelectedObject;
        this.setState({
            individualSelectedObject: {
                name,
                id
            },
            collapse_team_members: false
        })
    }

    searchMember = (e) => {
        const filteredIndividuals = this.state.individual_data_copy.filter(individual => {
            let name = individual.user__full_name ? individual.user__full_name : individual.user_email
          if(name.toLowerCase().includes(e.target.value.toLowerCase())) {
            return true
          }
          return false
        })

        const individualSelectedObject = this.state.individualSelectedObject

        if(individualSelectedObject.name.length) {
            const checkIfSelectedIndividualExist = filteredIndividuals.some((member, index) => {
                return member.assessment.id == individualSelectedObject.id
            })

            this.setState({
                individualSelectedObject: checkIfSelectedIndividualExist ? individualSelectedObject : {
                    name: '',
                    id: 0
                }
            })
        }

        this.setState({
            individual_members: e.target.value.length ? filteredIndividuals : this.state.individual_data_copy,
        })
    }

    render() {
        const { navData } = this.state;
        const { saveAssesorGroupListResponse, role_fitment_data_Loading, role_fitment_data_Error } = this.props;
      
        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                {
                        <SideNavBar
                            analyzeFilterData={saveAssesorGroupListResponse !== '' ? saveAssesorGroupListResponse : null}
                            isAnalyse = {true}
                            organisationName={localStorage.getItem('orgName')}
                            orgId={this.props.match.params.id}
                            teamId={localStorage.getItem('teamId')}
                            teamName={localStorage.getItem('teamName')}
                        />
                    }
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />

                        {
                            this.props.singleValidatorResponse ?
                                <p className="text-center m-3">
                                    Team Members should be more than 2
                                </p>
                            :
                                (!this.props.match.params.holder && !this.props.match.params.fitment) ?
                                    <div className="swot-container-sub" style={{ paddingLeft: 70, paddingRight: 70 }}>
                                        <h6 className="pt-5 text-center font-weight-bold">Analyze how well an individual fits into a role, based on standard competencies required to be effective in that role.</h6>
                                        <div className="d-flex flex-row justify-content-around align-items-start mb-3">
                                            {this.renderReusables({
                                                img: role_fitment_individualicon,
                                                name: "Individuals",
                                            })}
                                            {this.renderReusables({
                                                img: role_fitment_compatibilityIcon,
                                                name: "Holders",
                                            })}
                                            {this.renderReusables({
                                                img: role_fitment_compatibilityIcon,
                                                name: "Fitments",
                                            })}
                                        </div>
                                        <div className="d-flex flex-row justify-content-around align-items-start">
                                            <div className="filter border border-secondary rounded p-2" style={{ maxHeight: 300, overflowY: "scroll" }}>
                                                <div className="d-flex flex-row justify-content-between " onClick={() => this.setState({ collapse_team_members: !this.state.collapse_team_members })}>
                                                    <small className="mb-0" style={{ userSelect: 'none' }}>
                                                        {
                                                            this.state.individualSelectedObject.name.length ?
                                                                this.state.individualSelectedObject.name
                                                            :
                                                                "Select Individual"
                                                        }
                                                    </small>
                                                    {
                                                        this.state.collapse_team_members ?
                                                            <i className="fa fa-sort-up text-dark font-weight-bold mb-0"></i> :
                                                            <i className="fa fa-sort-down text-dark font-weight-bold mb-0"></i>
                                                    }
                                                </div>
                                                <Collapse
                                                    isOpen={this.state.collapse_team_members}
                                                >
                                                    <div className="d-flex p-1 align-items-center">
                                                        <i className="fa fa-search px-2" style={{color: '#797979'}}></i>
                                                        <input className="w-100" style={{outline: 'none'}} type="text" onChange={e => this.searchMember(e)} placeholder="Find a Member" />
                                                    </div>
                                                    {
                                                        this.state.individual_members.length == 0 ?
                                                            <div style={{ height: 10 }}>
                                                            </div> :
                                                            this.state.individual_members.map((obj, key) => {
                                                                return (
                                                                    <div key={key} className="d-flex flex-row pt-2 px-3">
                                                                        <label className="d-flex text-left" style={{ cursor: "pointer" }}>
                                                                            <input onChange={(e) => this.individualCheckFunction(e, obj.assessment.id, obj.user__full_name ? obj.user__full_name : obj.user_email)} checked={this.state.individualSelectedObject.name === (obj.user__full_name ? obj.user__full_name : obj.user_email)} type="radio" name="radio_individual" />
                                                                            <small className="px-2 mb-1 cursor-pointer">
                                                                                {obj.user__full_name ? obj.user__full_name : obj.user_email}
                                                                            </small>
                                                                        </label>
                                                                    </div>
                                                                )
                                                            })
                                                    }
                                                </Collapse>
                                            </div>

                                            <div className="filter border border-secondary rounded p-2" >
                                                <div className="d-flex flex-row justify-content-between " onClick={() => this.setState({ collapse_role: !this.state.collapse_role })}>
                                                    <small className="mb-0" style={{ userSelect: 'none' }}>
                                                        Select Holder
                                                    </small>
                                                    {
                                                        this.state.collapse_role ?
                                                            <i className="fa fa-sort-up text-dark font-weight-bold mb-0"></i> :
                                                            <i className="fa fa-sort-down text-dark font-weight-bold mb-0"></i>
                                                    }
                                                </div>
                                                <Collapse
                                                    isOpen={this.state.collapse_role}
                                                >
                                                    {
                                                        this.state.role_data.length == 0 ?
                                                            <div style={{ height: 10 }}>
                                                            </div> :
                                                            this.state.role_data.map((obj, key) => {
                                                                return (
                                                                    <div key={key} className="d-flex flex-row pt-2 px-3">
                                                                        <label style={{ cursor: "pointer" }}>
                                                                            <input onChange={(e) => this.roleCheckFunction(e, obj.id, obj.name)} checked={obj.isChecked} type="radio" name="radio" />
                                                                            <small className="px-2 mb-1 cursor-pointer">
                                                                                {obj.name}
                                                                            </small>
                                                                        </label>

                                                                    </div>
                                                                )
                                                            })
                                                    }
                                                </Collapse>
                                            </div>

                                            <div className={`filter border border-secondary rounded p-2 ${this.state.team_data.length ? '' : 'noTouching'}`} >
                                                <div className="d-flex flex-row justify-content-between " onClick={() => {
                                                    if(this.state.team_data.length) {
                                                        this.setState({ collapse_team: !this.state.collapse_team })
                                                    }
                                                }}>
                                                    <small className="mb-0" style={{ userSelect: 'none' }}>
                                                        Select Fitment
                                                    </small>
                                                    {
                                                        this.state.collapse_team ?
                                                            <i className="fa fa-sort-up text-dark font-weight-bold mb-0"></i> :
                                                            <i className="fa fa-sort-down text-dark font-weight-bold mb-0"></i>
                                                    }
                                                </div>
                                                <Collapse
                                                    isOpen={this.state.collapse_team}
                                                >
                                                    {
                                                        this.state.team_data.length == 0 ?
                                                            <div style={{ height: 10 }}>
                                                            </div> :
                                                            this.state.team_data.map((obj, key) => {
                                                                return (
                                                                    <div key={key} className="d-flex flex-row pt-2 px-3">
                                                                        <label>
                                                                            <input type="radio" className="cursor-pointer" name="filtment_radio" value={obj.name} checked={obj.isChecked} onChange={(e) => this.teamCheckFunction(e, obj.name)} />
                                                                            <small className="px-2 mb-1 cursor-pointer" >
                                                                                {obj.name}
                                                                            </small>
                                                                        </label>
                                                                    </div>
                                                                )
                                                            })
                                                    }
                                                </Collapse>
                                            </div>

                                        </div>
                                            <Button className="py-1 px-4 my-2" disabled={!this.applyButtonBool()} onClick={() => this.actionRoleFitment()}>Apply</Button>
                                    </div>
                                :
                                this.props.match.params.holder && this.props.match.params.fitment &&
                                    <React.Fragment>
                                        <div className="swot-container-sub my-5">
                                            {
                                                !role_fitment_data_Loading ?
                                                    this.state.data.length ?
                                                        <div>
                                                            <div className="d-flex justify-content-center drop-down-container mt-5 mb-3">
                                                                <h6 className=" mb-0 px-2 ">Role fitment of <span className="font-weight-bold">{this.getParticipantNameFromId()}</span> as <span className="font-weight-bold">{this.getFitmentsNameFromId()}</span></h6>
                                                            </div>
                                                            <div className="col- gradient-flex">
                                                                <div className="fitment-index-container text-center my-2">
                                                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                                                        <div className="col- mt-4 mr-2 fitment-index-body">
                                                                            <ReactSpeedometer
                                                                                width={350}
                                                                                height={200}
                                                                                forceRender={false}
                                                                                maxValue={100}
                                                                                value={this.state.speedoValue}
                                                                                needleTransition="easeBackOut"
                                                                                needleTransitionDuration={
                                                                                1000
                                                                                }
                                                                                ringWidth={39}
                                                                                needleColor="black"
                                                                                needleWidth={100}
                                                                                startColor="#e53935"
                                                                                segments={5}
                                                                                endColor="rgb(0,161,38)"
                                                                                role="role fitment"
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                    <p className="text-center font-weight-bold">Individuals ratings on the following competencies, needed for this role.</p>
                                                                    <CompetencyGraph
                                                                        data={this.state.data}
                                                                        Tooltip={this.state.Tooltip}
                                                                        selected_route_parameter={this.state.selected_route_parameter}
                                                                        onActionInvoked={(key, val) => this.onActionInvoked(key, val)}
                                                                        tableHeadingColor={this.state.headerColor}
                                                                        continuesHeading={this.state.continuesHeaderColor}
                                                                        barColor={this.state.graphColor}
                                                                        rowHighlightColor="grey"
                                                                        highlightTextColor="black"
                                                                        height={40}
                                                                        padding={'py-2 '}
                                                                        fontSize={14}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {
                                                                this.state.Tooltip ?
                                                                    <ModularTooltip modalHeader={true} toggleValue={this.state.Tooltip} id={`Target${`${this.state.selected_route_parameter}`}`} customComponent={this.renderCustomComponent(this.state.traceable_value, this.state.subData)} callbackPopover={this.callback.bind(this)} placement="right" title="Description and Attributes" /> :
                                                                    null
                                                            }
                                                        </div>
                                                    :
                                                        <p className="text-center mt-4">
                                                            Response is empty for the selected Individual
                                                        </p>
                                                :
                                                    role_fitment_data_Error ?
                                                        'Error occured while Calculating the data!'
                                                    :
                                                        <i className="fa fa-spinner fa-spin text-dark"></i>
                                            }
                                        </div>
                                    </React.Fragment>
                                
                        }
                    </div>
                </div>
            </div >
        )
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;


    const { role_user_FitmentError, role_user_FitmentLoading } = state.role_user_FitmentReducer;
    const role_user_FitmentData = (!role_user_FitmentError && !role_user_FitmentLoading) ? state.role_user_FitmentReducer.role_user_FitmentData : null

    const { holder_user_FitmentError, holder_user_FitmentLoading } = state.holder_user_FitmentReducer;
    const holder_user_FitmentData = (!holder_user_FitmentError && !holder_user_FitmentLoading) ? state.holder_user_FitmentReducer.holder_user_FitmentData : null


    const { role_fitment_data_Loading, role_fitment_data_Error } = state.role_fitment_data_Reducer;
    const role_fitment_data_Data = (!role_fitment_data_Loading && !role_fitment_data_Error) ? state.role_fitment_data_Reducer.role_fitment_data_Data : null


    const singleValidatorResponse = state.singleValidatorReducer.data;


    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,

        //holder and fitment list
        role_user_FitmentData,
        holder_user_FitmentData,

        role_fitment_data_Loading,
        role_fitment_data_Error,
        role_fitment_data_Data,

        singleValidatorResponse
    }
}

export default connect(mapStateToProps)(RoleFitment)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/RoleFitment/index.js